import React from 'react';
import { zcomLogo } from '../lib/zcomLogo';
import './ZcomLogo.css';

/**
 * The zcom logo: the dot spiral and the word, moving.
 *
 *   lockup   'inline' (spiral, then word — headers) | 'badge' (word set into
 *            the spiral — sign-in, splash)
 *   height   px; the width follows the drawing
 *   animated false draws it still
 *   loop     the word is written again every few seconds (splash only: in a
 *            header the name must stay readable)
 *
 * The word takes the text colour (`color` / a `text-…` class), so the same
 * logo sits on a white page or a dark one.
 */
export default function ZcomLogo({ lockup = 'inline', height = 40, animated = true, loop = false, className = '', style, ...rest }) {
  const { width, height: h, word, dots } = zcomLogo(lockup);
  const classes = ['zl', animated && 'zl--animated', animated && loop && 'zl--loop', className].filter(Boolean).join(' ');
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${width} ${h}`}
      height={height}
      width={Math.round((height * width) / h)}
      role="img"
      aria-label="zcom"
      className={classes}
      style={style}
      {...rest}
    >
      <g>
        {dots.map((dot) => (
          <circle
            key={dot.order}
            className="zl-dot"
            cx={dot.x}
            cy={dot.y}
            r={dot.r}
            fill={dot.fill}
            style={{ '--i': dot.order, '--d': dot.reach, '--h': dot.turn }}
          />
        ))}
      </g>
      <g fill="none" stroke="currentColor" strokeWidth={word.weight} strokeLinecap="round" strokeLinejoin="round">
        {word.letters.map((letter) => (
          <path key={letter.ch} className="zl-letter" d={letter.d} pathLength="1" style={{ '--k': letter.k }} />
        ))}
      </g>
    </svg>
  );
}
